import { Component, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StorageService } from '@core/services/util/storage.service';
import { LoginService } from '@core/services/login/login.service';
import { ToastrService } from '@core/services/notification/toastr.service';
import { UtilityService } from '@core/services/util/utility.service';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { PonchoUIModule } from '@poncho/ui';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-main-change-number',
    templateUrl: './main-change-number.component.html',
    styleUrls: ['./main-change-number.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, PonchoUIModule]
})
export class MainChangeNumberComponent {
    changeNumber: FormGroup;
    btnLoading = false;

    constructor(
        private loginService: LoginService,
        private utilityService: UtilityService,
        private authenticationService: AuthenticationService,
        private storageService: StorageService,
        private toastrService: ToastrService,
        private cdr: ChangeDetectorRef
    ) {
        const phoneRegex = this.utilityService.phoneRegex;
        this.changeNumber = new FormGroup({
            mobile: new FormControl('', Validators.compose([Validators.pattern(phoneRegex)]))
        });
    }

    changePhoneNumber() {
        if (!this.changeNumber.valid) {
            this.utilityService.markFormFieldsAsTouched(this.changeNumber);
            return;
        }

        this.btnLoading = true;
        this.loginService.ensureSessionId().then(() => {
            this.loginService
                .changeNumber(this.changeNumber.value.mobile)
                .toPromise()
                .then((data: any) => {
                    if (data && data.meta) {
                        this.storageService.set('phone_number', this.changeNumber.get('mobile').value);
                        if (data.meta.code === 200 || data.meta.code === 203) {
                            this.authenticationService.step.next('otp-verification');
                            this.authenticationService.mobileStep.next('otp-verification');
                            this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        } else if (data.meta.code === 202) {
                            this.authenticationService.step.next('signup-details');
                            this.authenticationService.mobileStep.next('signup-details');
                        } else if (data.meta.code === 400) {
                            this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                        }
                    }
                })
                .catch((error: any) => {
                    this.toastrService.openSnackBar(error?.meta?.message, 'OKAY');
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.cdr.markForCheck();
                });
        });
    }

    allowOnlyNumbers(event: KeyboardEvent | ClipboardEvent): boolean {
        return this.utilityService.allowOnlyNumbers(event);
    }
}
